import DefaultRedirect from '@features/groups/components/home/DefaultRedirect'
import HomeBMICharts from '@features/groups/components/home/HomeBMICharts'
import HomeDashboard from '@features/groups/components/home/HomeDashboard'
import HomeIncidents from '@features/groups/components/home/HomeIncidents'
import HomeProfile from '@features/groups/components/home/HomeProfile'
import HomeProfileEdit from '@features/groups/components/home/HomeProfileEdit'
import GroupHome from '@features/groups/screens/GroupHome'
import { Route } from 'react-router-dom'
import { ID, PROFILE } from './utils'

const HOMES_PATH = 'homes'
export const HOMES = {
  INDEX: HOMES_PATH,
  PROFILE: `${HOMES_PATH}/${ID}/${PROFILE}`,
  EDIT: `${HOMES_PATH}/${ID}/edit`,
  DASHBOARD: `${HOMES_PATH}/${ID}/dashboard`,
  INCIDENTS: `${HOMES_PATH}/${ID}/incidents`,
  BMI: `${HOMES_PATH}/${ID}/bmi`
}

export const homesRoutes = (
  <Route path={HOMES_PATH} element={<GroupHome />}>
    <Route index element={<DefaultRedirect listId="homes" />} />
    <Route path={`${ID}/${PROFILE}`} element={<HomeProfile />} />
    <Route path={`${ID}/edit`} element={<HomeProfileEdit />} />
    <Route path={`${ID}/dashboard`} element={<HomeDashboard />} />
    <Route path={`${ID}/incidents`} element={<HomeIncidents />} />
    <Route path={`${ID}/bmi`} element={<HomeBMICharts />} />
  </Route>
)
